import { LinienSymbol } from './linien-symbol.js';
import stile from './ki-hinweis.module.css';

/**
 * Dauerhafter Hinweis auf jeder Seite, die KI-Inhalte zur Freigabe oder als Ergebnis zeigt
 * (Freigabe Text, Freigabe Bilder, Ergebnis). Ergaenzt die einmalige Bestaetigung der
 * Nutzungsbedingungen im Willkommensdialog: dort einmal zugestimmt, hier jedes Mal erinnert.
 * Bewusst nicht wegklickbar. Eine flache Zeile als Karte wie die uebrigen Inhalte, nicht
 * `eds-alert`, und auf den Freigabeseiten unter der Kachel mit "Freigeben" statt ueber der
 * ganzen Breite (Rueckmeldung 2026-10-16).
 */
export function KiHinweis({ className }: { className?: string | undefined }) {
  return (
    <p
      className={className ? `${stile.hinweis} ${className}` : stile.hinweis}
      role="note"
      aria-label="KI-Hinweis"
    >
      <span className={stile.symbol}>
        <LinienSymbol name="alert" groesse={14} />
      </span>
      <span className={stile.text}>KI-generiert, vor Veröffentlichung prüfen</span>
    </p>
  );
}
